function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4325 0H1.09193C0.80233 0 0.524594 0.119106 0.319818 0.331116C0.115042 0.543127 0 0.830675 0 1.1305V12.6877C0 12.9875 0.115042 13.2751 0.319818 13.4871C0.524594 13.6991 0.80233 13.8182 1.09193 13.8182H11.4325C11.7221 13.8182 11.9999 13.6991 12.2046 13.4871C12.4094 13.2751 12.5245 12.9875 12.5245 12.6877V1.1305C12.5245 0.830675 12.4094 0.543127 12.2046 0.331116C11.9999 0.119106 11.7221 0 11.4325 0Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M29.5168 18.9091H19.1789C18.8893 18.9091 18.6115 19.0282 18.4068 19.2402C18.202 19.4522 18.087 19.7398 18.087 20.0396V30.8695C18.087 31.1693 18.202 31.4569 18.4068 31.6689C18.6115 31.8809 18.8893 32 19.1789 32H29.5168C29.8064 32 30.0841 31.8809 30.2889 31.6689C30.4937 31.4569 30.6087 31.1693 30.6087 30.8695V20.0396C30.6087 19.7398 30.4937 19.4522 30.2889 19.2402C30.0841 19.0282 29.8064 18.9091 29.5168 18.9091Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4298 18.9091H1.09193C0.80233 18.9091 0.524594 19.0282 0.319818 19.2402C0.115042 19.4522 0 19.7398 0 20.0396V30.8695C0 31.1693 0.115042 31.4569 0.319818 31.6689C0.524594 31.8809 0.80233 32 1.09193 32H11.4298C11.7194 32 11.9971 31.8809 12.2019 31.6689C12.4067 31.4569 12.5217 31.1693 12.5217 30.8695V20.0396C12.5217 19.7398 12.4067 19.4522 12.2019 19.2402C11.9971 19.0282 11.7194 18.9091 11.4298 18.9091Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6087 12.3636H22.6458C22.7595 12.3583 22.8708 12.3285 22.9727 12.2761C23.0746 12.2238 23.1648 12.15 23.2376 12.0595L31.5025 1.70834C31.7804 1.36038 31.7337 0.855092 31.3968 0.563935V0.563935C31.0407 0.256158 30.5001 0.306287 30.2066 0.674294L22.6087 10.2027L19.4694 6.00843C19.1099 5.52812 18.4051 5.48556 17.9904 5.91911V5.91911C17.6491 6.27592 17.63 6.83208 17.9459 7.21152L22.0294 12.1155C22.1055 12.1942 22.1958 12.2566 22.2952 12.2992C22.3946 12.3418 22.5011 12.3637 22.6087 12.3636Z",
  fill: "current"
});

function SvgOrderOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderOptions);
export default __webpack_public_path__ + "static/media/OrderOptions.17d0781b.svg";
export { ForwardRef as ReactComponent };